import User from './user';
import Orgs from './orgs';

export const API = {
  User,
  Orgs,
};
